export default __webpack_public_path__ + "static/media/telegram-plane-brands.0bd4e05f.svg";